"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_GAME: function() {
        return ADD_GAME;
    },
    DATE_PROGRESS_DAY: function() {
        return DATE_PROGRESS_DAY;
    },
    DATE_PROGRESS_MONTH: function() {
        return DATE_PROGRESS_MONTH;
    },
    GENERATE_GAME: function() {
        return GENERATE_GAME;
    },
    GENERATE_GAMES: function() {
        return GENERATE_GAMES;
    },
    RESET_GAME: function() {
        return RESET_GAME;
    },
    TRIGGER_MIGRATION: function() {
        return TRIGGER_MIGRATION;
    },
    UPDATE_GAME: function() {
        return UPDATE_GAME;
    },
    WEEK_PROCESS: function() {
        return WEEK_PROCESS;
    }
});
const RESET_GAME = "RESET_GAME";
const ADD_GAME = "ADD_GAME";
const UPDATE_GAME = "UPDATE_GAME";
const DATE_PROGRESS_DAY = "DATE_PROGRESS_DAY";
const DATE_PROGRESS_MONTH = "DATE_PROGRESS_MONTH";
const GENERATE_GAME = "GENERATE_GAME";
const WEEK_PROCESS = "WEEK_PROCESS";
const TRIGGER_MIGRATION = "TRIGGER_MIGRATION";
const GENERATE_GAMES = "GENERATE_GAMES";
